import { createTypes } from 'redux-action-types'
import api from '../api'
import { loadMagnets } from '../lib/magnets'

export const types = createTypes('fridge/sites/',
  'CHANGE',
  'SAVE',
  'DELETE',
  'LOAD_TOKENS',
  'SAVE_TOKEN'
)

export const change = async ({id}) => {
  const data = await api.get(`sites/${id}`, {expand: 'types,roles,groups'})
  try {
    await loadMagnets(data)
  } catch (err) {
    // failed to load magnets
  }

  // set fridgeId in API
  api.options.fridgeId = id

  return {type: types.CHANGE, data}
}

export const save = async (site, id = null) => {
  if (id) {
    const data = await api.put(`sites/${id}`, site)
    return {type: types.SAVE, data}
  }

  // create new site
  const data = await api.post('sites', site)
  return {type: types.SAVE, data}
  // redirect to ID
  // set role?
}

export const remove = async (site) => {
  await api.delete(`sites/${site.id}`)
  return {type: types.DELETE, data: site}
}

export const loadTokens = async (site) => {
  const data = await api.get(`sites/${site.id}/tokens`)
  return {type: types.LOAD_TOKENS, data}
}

export const saveToken = async (token, site) => {
  const data = await api.post(`sites/${site.id}/tokens`, token)
  return {type: types.SAVE_TOKEN, data}
}



// WEBPACK FOOTER //
// ./app/actions/sites.js